<template>
  <div class="the-navbar__user-meta flex items-center">
    <reset-user-password-side-bar :isResetPasswordSidebarActive="resetPasswordDataSidebar" @closeSidebar="ResetPasswordToggleDataSidebar" :data="passwordResetData" />

    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ ActiveUserName }}</p>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img ml-3">

        <img v-if="ActiveUserImage" key="onlineImg" :src="img_cdn + ActiveUserImage" width="40" height="40"
             class="rounded-full shadow-md cursor-pointer block"/>
        <span v-else class="userIfNotFound bg-primary"><p class="userFname text-white">{{ ImageNotFound }}<p/></span>
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown" ref="dropdown">
        <ul style="min-width: 12rem" @click="closedropdown()">

          <router-link :to="{ path: '/'+ $t('menu.users_profile.url')}" class="text-inherit">
            <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
              <feather-icon icon="UserIcon" svgClasses="w-4 h-4"/>
              <span class="ml-2" >Profile</span>
            </li>
          </router-link>
          <li @click="resetPassword(ActiveUserID)" class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="SettingsIcon" svgClasses="w-4 h-4"/>
            <span class="ml-2"  >Change Password</span>
          </li>
          <vs-divider class="m-1"/>
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2"  >Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import ResetUserPasswordSideBar from "@/views/cam-users/ResetUserPasswordSidebar";
import {LOGOUT, ROLES_KEY} from '@/graphql'

export default {
  components: {
    ResetUserPasswordSideBar

  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }  ,

  },

  data() {
    return {
      img_cdn:'',
      ActiveUserName: '',
      ActiveUserID: '',
      ActiveUserImage: '',
      resetPasswordDataSidebar: false,
      passwordResetData: '',
      UserData:'',
      ImageNotFound:'',

    }
  },

  watch:{
    UpdateRole () {
      return ROLES_KEY
    }
  },
  methods: {
    closedropdown(){
     this.$refs['dropdown'].$el.click();
    },
    resetPassword(UserID){

      this.passwordResetData = UserID
      this.ResetPasswordToggleDataSidebar(true)
    },
    ResetPasswordToggleDataSidebar (val = false) {
      this.resetPasswordDataSidebar = val
    },
    logout() {
      this.$router.replace('/login')
      localStorage.removeItem(ROLES_KEY)
      localStorage.setItem('user-roles', JSON.stringify({name: 'guest'}))
      localStorage.removeItem("userImage")
      localStorage.removeItem("userName")
      //send apollo api call
      this.$apollo
        .mutate({
          mutation: LOGOUT,
        })
        .then(response => {
          localStorage.removeItem(ROLES_KEY)
          localStorage.removeItem('userId')
          //show sucess notification
          this.StatusSuccess()
          //set role as guest when logged out
          localStorage.setItem('user-roles', JSON.stringify({name: 'guest'}))

        })


    },
    StatusSuccess() {
      this.$vs.notify({
        title: "User",
        text: 'Logged Out Successfully!',
        color: 'success',
        position: 'top-right'
      })

    },

  },
  created() {

    // localStorage.removeItem('userImage')
    // localStorage.removeItem('userImageNotFound')

    var checkimage = localStorage.getItem('userImage')

    if (localStorage.getItem("userImage") !== null) {

      this.ActiveUserImage = checkimage
      this.ActiveUserName = localStorage.getItem('userName')
      localStorage.removeItem('userImageNotFound')

    } else {
      this.ActiveUserName = localStorage.getItem('userName')
      localStorage.setItem('userImageNotFound', this.ActiveUserName[0].toUpperCase())
      this.ImageNotFound = localStorage.getItem('userImageNotFound')
    }
    // localStorage.setItem('userImageNotFound'," ")
    // this.ImageNotFound =localStorage.getItem('userImageNotFound')
    //
    // this.ActiveUserID = localStorage.getItem('userId')
    // this.img_cdn=process.env.VUE_APP_IMAGES_CDN_LINK
    //
    // this.$apollo
    //   .query({
    //     query: ME_DATA,
    //   })
    //   .then(response => {
    //     if(response.data.me !=null) {
    //       this.UserData = response.data.me
    //       if (!this.UserData.avatar) {
    //
    //         localStorage.setItem('userImageNotFound',this.UserData.fname[0].toUpperCase())
    //         this.ImageNotFound =localStorage.getItem('userImageNotFound')
    //         localStorage.removeItem('userImage')
    //
    //       } else {
    //
    //        localStorage.setItem('userImage',this.UserData.avatar)
    //
    //        localStorage.setItem('userName',this.UserData.fname + ' ' + this.UserData.lname )
    //         localStorage.removeItem('userImageNotFound')
    //         this.ImageNotFound = null
    //       }
    //     }else {
    //       window.location('login')
    //     }
    //   })
    // this.ActiveUserImage = localStorage.getItem('userImage')
    // this.ActiveUserName = localStorage.getItem('userName')
    this.img_cdn = process.env.VUE_APP_IMAGES_CDN_LINK
  }
}
</script>
<style>
.userIfNotFound {
  height: 40px;
  line-height:23px;
  text-align:center;
  width: 40px;
  border-radius: 50%;
  display: inline-block;
}
.userFname{
  margin: 8px 0px 0px 0px;
  font-weight: 400;
  font-size: 23px;

}
</style>
